import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { VOID } from '@frontend-site/shared/utils';
import { forkJoin, Observable, switchMap, tap } from 'rxjs';
import { SystemService } from '../system';
import { ProjectService } from './project.service';
import { ProjectStore } from './project.store';
import { RdxContextStore } from '../rdx/rdx-context.store';
import { RdxContextType } from '../rdx/rdx-context-type.enum';
import { SessionRepository } from '../session';
import { UsersService } from '../user';

@Injectable({
    providedIn: 'root'
})
export class ProjectResolver  {
    constructor(
        private store: ProjectStore,
        private projectService: ProjectService,
        private systemService: SystemService,
        private usersService: UsersService,
        private rdxContextStore: RdxContextStore,
        private sessionStore: SessionRepository
    ) {}

    resolve(route: ActivatedRouteSnapshot): Observable<void> {
        const { projectId } = route.params;

        if (!projectId || this.store.projectId === +projectId || isNaN(+projectId)) {
            return VOID;
        }
        const projectIdAsNumber = Number(projectId);
        return this.projectService.loadProjectDetails(projectId).pipe(
            tap(() => {
                if (this.sessionStore.applicationConfig) {
                    this.rdxContextStore.updateContext(projectIdAsNumber, RdxContextType.PROJECT, this.sessionStore.applicationConfig);
                }
            }),
            switchMap((projectInfo) =>
                forkJoin([
                    this.systemService.loadSystemDetails(projectInfo.systemId),
                    this.usersService.loadProjectUsers(projectIdAsNumber)
                ])
            ),

            switchMap(() => VOID)
        );
    }
}
